<table class="credittable" mat-table [dataSource]="dataSource" matSortDirection="desc"
  matSort (matSortChange)="announceSortChange($event)">
  <ng-container matColumnDef="billTo">
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true" sortActionDescription="Sort by Address">
      <span class="th_Headings">{{'financialDashboard.billing_heading' | cxTranslate}}</span>
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.billTo.billingAddress }}
    </td>
  </ng-container>

  <ng-container matColumnDef="invoiceDate">
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true" sortActionDescription="Sort by Date"
      aria-sort="ascending">
      <span class="th_Headings">{{ (dataTable === 3 ? 'financialDashboard.date_Applied_heading'  : 'financialDashboard.date_issue_heading') | cxTranslate}}</span>
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.invoiceDate }}
    </td>
  </ng-container>

  <ng-container matColumnDef="invoiceNumber">
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true" class="creditWhiteSpace"
      sortActionDescription="Sort by Credit">
      <span class="th_Headings">{{'financialDashboard.credit_Note_heading' | cxTranslate}}</span>
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.invoiceNumber }}
    </td>
  </ng-container>

  <ng-container matColumnDef="formattedAmountWithTax">
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true" class="creditWhiteSpace"
      sortActionDescription="Sort by Amount">
      <span class="th_Headings">{{'financialDashboard.credit_Amount_heading' | cxTranslate}}</span>
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.formattedAmountWithTax }}
    </td>
  </ng-container>
  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element; let i = index">
      <div class="col-sm-12 no-padding">
        <div class="viewreportchild">
          <a class="anchorlink" (click)="financialgetDownloadInvoiceData(element.invoiceNumber)"><span
          class="anchorunderline">{{'financialDashboard.view_Report' | cxTranslate}}</span>
          <div class="global_blackarrow"></div>
        </a>
      </div>
      <div class="clearBoth"></div>
      @if (element.isDownloading) {
        <div class="download_txt"><img src="../assets/images/loading_download.gif"
        width="20px" alt="Loading...">&nbsp;{{'financialDashboard.downloading_Msg' | cxTranslate}}</div>
      }
    </div>
  </td>
</ng-container>

<tr mat-header-row *matHeaderRowDef="creditcolumns"></tr>
<tr mat-row *matRowDef="let row; columns: creditcolumns"></tr>
<tr class="mat-row" *matNoDataRow>
  <td class="mat-cell no-matching-invoices">
    {{'financialDashboard.no_Match' | cxTranslate}}
  </td>
</tr>
</table>
<!-- For mobile view credits table-->
<div class="mobile_Credit_Table_Container">
  <table mat-table [dataSource]="dataSource" id="creditcolumns_Mobile_Table" matSort multiTemplateDataRows matSortDirection="desc" matSort (matSortChange)="announceSortChange($event)">
    <ng-container matColumnDef="combined">
      <th class="schedulepaymentheader d-none" mat-header-cell *matHeaderCellDef> credit columns Data </th>
      <td mat-cell *matCellDef="let element" class="credit_Mobile_Table">
        <div class="credit_Mobile_Table">
          <!--Billing Adress-->
          <div class="credit_Billing_Adress">
            <div class="table_header">{{'financialDashboard.billing_heading' | cxTranslate}}</div>
            <div class="table_value">{{ element.billTo.billingAddress }}</div>
          </div>
          <!--Invoice Date-->
          <div class="credit_Mobile_Data">
            <div class="table_header">{{'financialDashboard.date_issue_heading' | cxTranslate}}</div>
            <div class="table_value">{{ element.invoiceDate }}</div>
          </div>
          <!--Invoice Number-->
          <div class="credit_Mobile_Data">
            <div class="table_header">{{'financialDashboard.credit_Note_heading' | cxTranslate}}</div>
            <div class="table_value">{{ element.invoiceNumber }}</div>
          </div>
          <!--Formattef Amount with Tax-->
          <div class="credit_Mobile_Data">
            <div class="table_header">{{'financialDashboard.credit_Amount_heading' | cxTranslate}}</div>
            <div class="table_value">{{ element.formattedAmountWithTax }}</div>
          </div>
          <!--View Report-->
          <div class="view_Report_Data">
            <div class="table_header"></div>
            <div class="table_value view_Report_Table">
              <a class="anchorlink" (click)="financialgetDownloadInvoiceData(element.invoiceNumber)"><span
              class="anchorunderline">{{'financialDashboard.view_Report' | cxTranslate}}</span>
              <div class="global_blackarrow"></div>
            </a>
            <div class="clearBoth"></div>
            @if (element.isDownloading) {
              <div class="download_txt"><img src="../assets/images/loading_download.gif"
              width="20px" alt="Loading...">&nbsp;{{'financialDashboard.downloading_Msg' | cxTranslate}}</div>
            }
          </div>
        </div>
      </div>
    </td>
  </ng-container>
  <tr mat-row *matRowDef="let row; columns: creditMobileColumns" class="table-row"></tr>
  <tr mat-header-row *matHeaderRowDef="creditMobileColumns" class="header-row"></tr>
  <tr class="mat-row" *matNoDataRow>
    <td class="mat-cell no-matching-invoices">
      {{'financialDashboard.no_Match' | cxTranslate}}
    </td>
  </tr>
</table>
</div>
